import { Box, makeStyles, styled, Typography } from "@material-ui/core";
import Button from "components/design-system/atoms/Button";
import { Body } from "../design-system/atoms/Typography";
import InformationDrawer from "../design-system/molecules/InformationDrawer";
import ConnectedAdressForm from "./ConnectedAddressForm";
import LocalOfferDrawerContent from "./LocalOfferBlockDrawerContent";

const BackgroundBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.green,
  color: theme.palette.secondary.main,
}));

export default function LocalOfferTile({ addCatalogsToRefinementList, addressAutocompleteId = "local-tile" }) {
  const classes = useStyle();

  return (
    <BackgroundBox className={classes.container}>
      <Box pt={"80px"} pb={2} px={3} className={classes.insideBox}>
        <Box maxWidth={260} margin="0 auto">
          <Box mb={2}>
            <Typography variant="h2" className={classes.title}>
              Urgent ? Récupérez votre appareil demain dans nos ateliers
            </Typography>
          </Box>
          <Box mb="20%">
            <Typography variant="body2" className={classes.bodyText}>
              Des appareils près de chez vous livrés <b>en 48h ou que vous pourrez récupérer gratuitement</b> dans nos
              ateliers. &nbsp;
            </Typography>
          </Box>
        </Box>
        <Box className={classes.addressForm}>
          <ConnectedAdressForm
            id={addressAutocompleteId}
            autoFocusField={false}
            addCatalogsToRefinementList={addCatalogsToRefinementList}
            disabled={false}
            vertical
          >
            <Box mt={3}>
              <Button type="submit" version="green_and_light_green">
                Voir les produits régionaux
              </Button>
            </Box>
          </ConnectedAdressForm>
          <Box>
            <InformationDrawer
              anchor="right"
              title="Disponibles près de chez vous"
              width="fit-content"
              button={
                <Body textAlign="center" mt={3}>
                  <u>En savoir +</u>
                </Body>
              }
            >
              {() => <LocalOfferDrawerContent />}
            </InformationDrawer>
          </Box>
        </Box>
      </Box>
    </BackgroundBox>
  );
}

const useStyle = makeStyles(() => ({
  addressForm: {
    marginBottom: "15%",
  },
  container: {
    maxHeight: 700,
    height: "100%",
    backgroundPositionX: "center",
    borderRadius: 20,
    backgroundSize: "cover",
  },
  insideBox: {
    display: "grid",
    height: "100%",
  },
  title: {
    textAlign: "center",
  },
  bodyText: {
    textAlign: "center",
  },
}));
